import React from 'react';
import styled from 'styled-components';
import Content from 'gatsby-theme-core/src/components/content';
import Form from '../../../../components/form';

const ModalForm = ({
  // id,
  strapiForm,
}) => (
  <Content>
    <Form {...strapiForm} />
  </Content>
);

export default styled(ModalForm)``;
